import { useBreakpointValue } from "@chakra-ui/react"
import React from "react"
import CloudBrowserModalDesktop from "./CloudBrowserModalDesktop"
import CloudBrowserModalMobile from "./CloudBrowserModalMobile"

interface Props {
  isOpen: boolean
  onClose: () => void
}

const CloudBrowserModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const isMobile = useBreakpointValue({
    base: true,
    md: false,
  })

  if (isMobile) {
    return <CloudBrowserModalMobile isOpen={isOpen} onClose={onClose} />
  }

  return <CloudBrowserModalDesktop isOpen={isOpen} onClose={onClose} />
}

export default CloudBrowserModal
